import JSONPretty from 'react-json-pretty'

export const JSONStyled = ({ data }: Readonly<{ data?: any }>) => (
  <JSONPretty
    className='w-full rounded-lg border border-neutral-75 bg-neutral-25 p-6 font-mono text-xs leading-6 json-key:font-bold json-string:whitespace-pre-line json-string:text-[#556C79] json-boolean:text-indigo-600 json-value:text-error-300'
    data={data}
  />
)
